import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const projectCarousel = {
	init() {

        // init Swiper:
        const swiper = new Swiper('.js-swiper', {
            slidesPerView: "auto",
            spaceBetween: 80,            
            // configure Swiper to use modules
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },            
        });

        let carousels = document.querySelectorAll('.js-swiper');
        if (carousels.length > 0){
            carousels.forEach(function(carousel) {
                const btn = carousel.querySelector('.swiper-button-next');
                const slide = carousel.querySelectorAll('.swiper-slide')[0];
                const imgHeight = slide.querySelector('.js-featured-project-img').offsetHeight;
                
                if (imgHeight !== null) {
                    btn.style.top = 'auto';
                    btn.style.bottom = (imgHeight/2) - (btn.offsetHeight/2) + 'px';
                }
            });
        }

	},
};

export default projectCarousel;
